<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Opções base de financiamento</div>
                <div class="text text--thin mb-2">Adicione opções de financiamento que serão utilizados ao criar um orçamento</div>
                <v-btn @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">price_change</v-icon>Nova opção</v-btn>
              </v-col>
              <v-col cols="12" md="5">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
      <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2 table_search_area">
              <v-text-field
                clearable
                hide-details=""
                clear-icon="close"
                v-model="search"
                outlined
                label="Busca"
              ></v-text-field>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.bop_tipo="{ item }">
          {{ calculos[item.bop_tipo - 1].text }}
        </template>
        <template v-slot:item.bop_parcelas="{ item }">
          {{ item.bop_parcelas }}x
        </template>
        <template v-slot:item.bop_entrada="{ item }">
          {{ item.bop_entrada.replace('.', ',') }}%
        </template>
        <template v-slot:item.bop_juro_mensal="{ item }">
          {{ item.bop_juro_mensal.replace('.', ',') }}%
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="550px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{opcao.uuid_bop_id ? 'Editar opção' : 'Novo opção'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formOptions">
          <v-row>
            <v-col v-if="$root.Permissions.admin()" cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="opcao.uuid_int_id"
                :items="integradores"
                clearable
                clear-icon="close"
                label="Integrador"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="opcao.bop_nome"
                label="Nome* Ex: Financiamento PF ou Financiamento PJ"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                v-model="opcao.bop_tipo"
                autocomplete="on"
                :items="calculos"
                :rules="[rules.required]"
                :loading="salvando"
                :disabled="salvando"
                label="Tipo de cálculo*"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="opcao.bop_parcelas"
                label="Qtde de parcelas em meses* Ex: 24"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0">
              <v-text-field-percent
                label="Percentual de entrada (%)*"
                v-model="opcao.bop_entrada"
                :rules="[rules.required]"
                suffix=""
                v-bind:properties="{
                  readonly: false,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: null,
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0">
              <v-text-field-percent
                label="Taxa de juros mensal (%)*"
                v-model="opcao.bop_juro_mensal"
                :rules="[rules.required]"
                suffix=""
                v-bind:properties="{
                  readonly: false,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: null,
                }"
              ></v-text-field-percent>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditOption()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Opção
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelOptionDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir opção <b class="text-primary">{{opcao.bop_nome}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            @click="cancelOptionDelete()"
            :loading="salvando"
            :disabled="salvando"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeOption()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      search: '',
      modulos: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'bop_id'
        },
        { text: 'Nome', value: 'bop_nome' },
        { text: 'Tipo de cálculo', value: 'bop_tipo' },
        { text: 'Parcelas', value: 'bop_parcelas' },
        { text: 'Entrada', value: 'bop_entrada' },
        { text: 'Taxa de juros mensal', value: 'bop_juro_mensal' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      integradores: [],
      calculos: [
        {
          text: 'Tabela Price',
          value: 1
        },
        {
          text: 'Tabela Sac',
          value: 2
        }
      ],
      opcao: {
        uuid_int_id: '',
        bop_nome: '',
        bop_tipo: 1,
        bop_padrao: false,
        bop_parcelas: '',
        bop_entrada: '',
        bop_juro_mensal: ''
      }
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        type: 'opcoes-base-financiamento'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      this.getOptions()
      this.getIntegrators()
    },
    async getIntegrators () {
      await Api.get('integradores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_int_id,
                text: item.int_nome
              })
            })
            this.integradores = info
          }
        })
    },
    async getOptions () {
      this.loading = true
      this.dados = []
      await Api.get('bancos/opcoes/gerais')
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.dados = res.data
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response && err.response.data ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as opções de financiamento!',
            color: 'error'
          })
          console.log(err)
        })
    },
    saveEditOption () {
      if (!this.$refs.formOptions.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }

      this.salvando = true

      let endpoint = 'bancos/geral/opcoes/novo'
      let editado = false
      if (this.opcao.uuid_bop_id) {
        endpoint = 'bancos/geral/opcoes/edita'
        editado = true
      }

      this.opcao.bop_padrao = true

      Api.post(endpoint, this.opcao)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Opção atualizada com sucesso!' : 'Opção cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getOptions()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeOption () {
      this.salvando = true
      Api.delete(`bancos/geral/opcoes/remove/${this.opcao.uuid_bop_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getOptions()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover opção de financiamento!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.opcao = JSON.parse(JSON.stringify(item))
      console.log(this.opcao, 'this.opcao')
      this.dialogNovo = true
    },
    cancelOptionDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    openDialogDelete (item) {
      this.opcao = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    closeDialog () {
      this.opcao = {
        uuid_int_id: '',
        bop_nome: '',
        bop_tipo: 1,
        bop_padrao: false,
        bop_parcelas: '',
        bop_entrada: '',
        bop_juro_mensal: ''
      }
      if (this.$refs.formOptions) {
        this.$refs.formOptions.resetValidation()
      }
      this.dialogNovo = false
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/OpcoesFinanciamento.vue